/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Issue_Sign_Missing_BsInputs */

const en_statement_taxonomy_issue_sign_missing_bs = /** @type {(inputs: Statement_Taxonomy_Issue_Sign_Missing_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The balance sheet needs both debit and credit rows`)
};

const nl_statement_taxonomy_issue_sign_missing_bs = /** @type {(inputs: Statement_Taxonomy_Issue_Sign_Missing_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De balans heeft zowel debet- als creditregels nodig`)
};

/**
* | output |
* | --- |
* | "The balance sheet needs both debit and credit rows" |
*
* @param {Statement_Taxonomy_Issue_Sign_Missing_BsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_issue_sign_missing_bs = /** @type {((inputs?: Statement_Taxonomy_Issue_Sign_Missing_BsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Issue_Sign_Missing_BsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_issue_sign_missing_bs(inputs)
	return en_statement_taxonomy_issue_sign_missing_bs(inputs)
});